class OrderProduct{
    constructor(product_id,number){
        this.product_id=product_id;
        this.number=number;
    }
}

export default OrderProduct;